// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Zone from "@insite/client-framework/Components/Zone";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import ReportContainer from "@store/Library/Components/Reporting/Common/ReportContainer";
import LinkCard from "@store/Library/Components/Reporting/LinkCard/LinkCard";
import Colors from "@store/Themes/common/styleguide/config/colors";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import React from "react";
import styled from "styled-components";

const containerMediaQuery = getMediaQuery({ option: "only", first: false, min: 1800, max: 3000, last: true });
const FlexContainer = styled.div`
    display: flex;
    row-gap: 7rem;
    column-gap: 7rem;
    padding: 2.5vh 10%;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    ${containerMediaQuery} {
        padding: 5vh 10%;
    }
`;

const FlexColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 1rem;
`;

export interface LinkData {
    link: string;
    title: string;
}
// not accessing through the theme object.  Will refactor later.

const colors = [Colors?.primary?.main || "", Colors?.primary?.contrast || "", Colors?.common?.borderColored || ""];
const LinkPage = () => {
    const links = useAppSelector(state => getPageLinkByNodeId(state, getCurrentPage(state).nodeId));
    const children = links?.children ? [...links.children.filter(child => !child.excludeFromNavigation)] : [];

    children.sort((a, b) => {
        if (a.type?.toLowerCase().includes("invoice")) {
            return -1;
        }
        if (b.type?.toLowerCase().includes("budget")) {
            return -1;
        }
        if (b.type?.toLowerCase().includes("invoice")) {
            return 1;
        }
        return 0;
    });
    return (
        <ReportContainer>
            <FlexColumnContainer>
                <Zone contentId="Title" zoneName="Title" />

                <FlexContainer>
                    {children.map((linkData, index) => {
                        return (
                            <LinkCard
                                linkData={linkData}
                                delay={index * 100}
                                color={colors[index % 3]}
                                key={linkData.title}
                            />
                        );
                    })}
                </FlexContainer>
            </FlexColumnContainer>
        </ReportContainer>
    );
};
const widgetModule: CustomWidgetModule = {
    component: LinkPage,
    definition: {
        group: "Reporting",
        displayName: "Link Page",
    },
};
export default widgetModule;
